import axios from 'axios';
export class PolicyError extends Error {
    constructor(message, code) { super(message); this.code = code; }
}
export const policyErrorText = error => ({
    9999: '관리자 로그인이 만료되었습니다. 다시 로그인해주세요.',
    4031: 'SUPER 권한이 필요합니다.',
    4032: '보안 검증에 실패했습니다. 설정을 다시 조회해주세요. 문제가 계속되면 CSRF·Origin·JSON 설정을 확인해주세요.',
    4000: '입력값을 확인해주세요.', 4004: '가맹점을 확인해주세요.',
    4090: '설정이 변경되었습니다. 최신 설정을 조회한 뒤 변경 내용을 다시 확인해주세요.',
    4091: '같은 요청 번호에 다른 내용이 등록되어 있습니다. 자동 재시도를 중단했습니다. 최신 설정과 이력을 확인해주세요.',
    5031: '서버 오류로 저장 결과를 확인하지 못했습니다. 기존 표시값을 유지합니다.',
})[error?.code] || error?.message || '요청 결과를 확인하지 못했습니다.';
export const policyPath = (mode, mid) => mode === 'agent' ? `/api/agent-security/policy/${encodeURIComponent(mid)}` : mode === 'control' ? '/api/merchant-security/transfer-control' : `/api/merchant-security/policy/${encodeURIComponent(mid)}`;
export function validatePolicy(data, mode, mid) {
    if (!data || !((typeof data.version === 'string' && data.version.trim()) || Number.isSafeInteger(data.version))
        || typeof data.csrf_token !== 'string' || !data.csrf_token.trim()) throw new PolicyError('설정 버전 또는 보안 토큰을 확인하지 못했습니다.');
    const fields = mode === 'control' ? ['enabled', 'accept_requests'] : mode === 'agent' ? ['login_pin_required', 'withdraw_pin_required'] : ['login_pin_required', 'withdraw_pin_required', 'default_required'];
    if (fields.some(k => typeof data[k] !== 'boolean') || (mode !== 'control' && ((mode === 'agent' ? data.agent_id != null && String(data.agent_id) !== String(mid) : data.mid !== mid) || typeof data.version !== 'string'))) throw new PolicyError('설정 응답이 올바르지 않습니다. OFF로 처리하지 않습니다.');
    return data;
}
export async function getPolicy(path, mode, mid) {
    let r;
    try { r = await axios.get(process.env.REACT_APP_API + path, { withCredentials: true, timeout: 15000 }); }
    catch (e) { throw new PolicyError(e.response?.data?.msg || '설정을 조회하지 못했습니다.', e.response?.data?.code); }
    if (r.data?.code !== 1000) throw new PolicyError(r.data?.msg, r.data?.code);
    return validatePolicy(r.data.data, mode, mid);
}
export async function patchPolicy(path, body, csrf) {
    let r;
    try { r = await axios.patch(process.env.REACT_APP_API + path, body, { withCredentials: true, timeout: 15000,
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf } }); }
    catch (e) { throw new PolicyError(e.response?.data?.msg || '응답을 받지 못했습니다. 같은 요청으로 결과를 확인해주세요.', e.response?.data?.code); }
    if (r.data?.code !== 1000) throw new PolicyError(r.data?.msg || '저장 결과를 확인하지 못했습니다.', r.data?.code);
}
export function policyUuid() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    const a = window.crypto.getRandomValues(new Uint8Array(16)); a[6] = (a[6] & 15) | 64; a[8] = (a[8] & 63) | 128;
    const s = [...a].map(v => v.toString(16).padStart(2, '0')).join('');
    return `${s.slice(0,8)}-${s.slice(8,12)}-${s.slice(12,16)}-${s.slice(16,20)}-${s.slice(20)}`;
}
